import React, { useContext, useState } from "react";
import { EditorContext, ModalServiceContext, RicosContext } from "./../ricos-context/index.js";
import { useBiNext } from "./../_shared/bi-context-provider/bi-context-provider.js";
import { isHexColor, resolveColorsPalette } from "./../wix-rich-content-common/index.js";
import { NewColorPicker } from "./../ui-components/color-picker/new-color-picker/index.js";
import { TEXT_COLOR_MODAL_ID, TEXT_HIGHLIGHT_MODAL_ID } from "./constants.js";
const TextColorPicker = ({ type, config, referenceElement }) => {
  const { t } = useContext(RicosContext);
  const { getPublicCommands } = useContext(EditorContext);
  const { adapter } = useContext(EditorContext);
  const modalService = useContext(ModalServiceContext);
  const isTextHighlightModal = type === "ricos-text-highlight";
  const modalId = isTextHighlightModal ? TEXT_HIGHLIGHT_MODAL_ID : TEXT_COLOR_MODAL_ID;
  const pluginId = isTextHighlightModal ? "textHighlight" : "textColor";
  const logBi = useBiNext({ modalId, pluginId });
  const activeColor = getPublicCommands()?.getColor?.(type);
  const currentColor = activeColor && isHexColor(activeColor) ? activeColor.toUpperCase() : activeColor;
  const themeColors = resolveColorsPalette(
    config.colorScheme ? Object.values(config.colorScheme).map((c) => c.color) : [],
    void 0,
    58
  );
  const [customColors, setCustomColors] = useState(
    () => resolveColorsPalette(config.getUserColors?.() ?? [], currentColor, 58)
  );
  const closeModal = () => {
    modalService.closeModal(modalId);
  };
  const onColorSelected = (color) => {
    getPublicCommands()?.insertDecoration(type, { color });
  };
  const onColorAdded = (color) => {
    config.onColorAdded?.(color);
    setCustomColors((prev) => [...prev, color]);
    getPublicCommands()?.insertDecoration(type, { color });
  };
  const onResetColor = () => {
    getPublicCommands()?.deleteDecoration(type);
  };
  const onPreview = (color) => {
    const previewCommand = isTextHighlightModal ? "previewHighlight" : "previewColor";
    adapter.tiptapEditor.chain()[previewCommand](color).run();
  };
  const onColorPreviewStart = (color) => (
    // @ts-ignore $TSFixMe
    onPreview(color)
  );
  const onColorPreviewEnd = () => onPreview(null);
  return /* @__PURE__ */ React.createElement(
    NewColorPicker,
    {
      title: isTextHighlightModal ? t("Color_Picker_TextHighlightButton_Header") : t("Color_Picker_TextColorButton_Header"),
      currentColor,
      themeColors,
      customColors,
      closeModal,
      onColorSelected,
      onColorAdded,
      onColorPreviewStart,
      onColorPreviewEnd,
      onResetColor,
      referenceElement,
      logBi
    }
  );
};
export {
  TextColorPicker
};
//# sourceMappingURL=TextColorPicker.js.map
